import { Link, SxProps } from "@mui/material";
//import { links } from "helpers/linksConfig";
import { useGoogleAnalyticsContext } from "contexts/GoogleAnalyticsProvider";
import { useLinks } from "hooks/useLinks";
import { appleStoreIconPath, googleStoreIconPath } from "utils/svgIcons";

const AppStoreButton = ({
	type,
	source,
	className = "",
	sx = {}
}: {
	type: "apple" | "google";
	source: string;
	className?: string;
	sx?: SxProps;
}) => {
	const links = useLinks();
	const { reportEvent, reportPlaygamiEvent } = useGoogleAnalyticsContext();

	const props = {
		className,
		sx,
		component: "a",
		target: "_blank",
		rel: "noreferrer"
	};
	const appleProps = {
		...props,
		onClick: () => {
			reportEvent(links.appstore_apple.analytics_key, { source });
			reportPlaygamiEvent("tp.web_frontend", {
				event_name: links.appstore_apple.analytics_key,
				event_type: "left_menu",
				action: links.appstore_apple.analytics_key,
				source
			});
		},
		href: links.appstore_apple.path,
		title: links.appstore_apple.title
	};
	const googleProps = {
		...props,
		onClick: () => {
			reportEvent(links.appstore_google.analytics_key, { source });
			reportPlaygamiEvent("tp.web_frontend", {
				event_name: links.appstore_google.analytics_key,
				event_type: "left_menu",
				action: links.appstore_google.analytics_key,
				source
			});
		},
		href: links.appstore_google.path,
		title: links.appstore_google.title
	};
	return type === "apple" ? (
		<Link {...appleProps}>
			<img src={appleStoreIconPath} alt={appleProps.title} />
		</Link>
	) : (
		<Link {...googleProps}>
			<img src={googleStoreIconPath} alt={googleProps.title} />
		</Link>
	);
};

export default AppStoreButton;
